import FetchService from '../../../core/services/FetchService';
import { action, extendObservable } from 'mobx';

class SystemTranslationInstructionAudioProgressService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      progress: {
        percentage: 0,
        translated: 0,
      },
    });
  }

  init = action((locale) => {
    this.load(locale);
  });

  load = action((locale) => {
    this.fetch
      .fetch({
        url: `/instruction-audios/${locale.key}/translated-percentage`,
      })
      .then(() => {
        if (this.fetch.data) {
          this.progress = this.fetch.data;
        }
        if (this.fetch.error) {
          this.progress = {};
        }
      });
  });
}

export default SystemTranslationInstructionAudioProgressService;
